<template>
  <div>
    <el-scrollbar style="height:100%;">
      <el-menu
          :default-active="active"
          class="el-menu-vertical-demo"
          background-color="#212A3D" text-color="#fff"
          @open="handleOpen"
          @close="handleClose"
          @select="handleSelect">
        <!-- <el-menu-item index="monitor" :disabled="!this.connected">
          <i class="iconfont iconjiankongshebeiguanli" style="font-size: 24px"></i>
          <span slot="title">{{ $t('sidebar.monitor') }}</span>
        </el-menu-item>
        <el-menu-item index="query" :disabled="!this.connected">
          <i class="iconfont iconchaxun"></i>
          <span slot="title">{{ $t('sidebar.query') }}</span>
        </el-menu-item>
        <el-menu-item index="test" :disabled="!this.connected">
          <i class="iconfont iconceshi"></i>
          <span slot="title">{{ $t('sidebar.test') }}</span>
        </el-menu-item>
        <el-menu-item index="setting" :disabled="!this.connected">
          <i class="iconfont iconshezhi"></i>
          <span slot="title">{{ $t('sidebar.setting') }}</span>
        </el-menu-item>
        <el-menu-item index="install" :disabled="!this.connected">
          <i class="iconfont iconanzhuang"></i>
          <span slot="title">{{ $t('sidebar.install') }}</span>
        </el-menu-item>
        <el-menu-item index="system">
                  <i class="iconfont iconxitong"></i>
                  <span slot="title">{{ $t('sidebar.system') }}</span>
                </el-menu-item>-->
        <!-- <el-menu-item index="management">
          <i class="iconfont iconjichuguanli"></i>
          <span slot="title">{{ $t('sidebar.manage') }}</span>
        </el-menu-item> -->
        <!-- v-if="item.auth === management ? uesrAuth.includes(item.auth) : uesrAuth.includes(item.auth) && controlAuth.includes(item.auth)" -->
        <template v-for="(item,index) in siderBarList">
         <el-menu-item :index="item.index"  :key="index"
            :disabled="(item.setDisable ? item.setDisable : (item.disabledActive ? !connected : false))"
            v-if="item.auth === 'management' ? uesrAuth.includes(item.auth) : uesrAuth.includes(item.auth) && controlAuth.includes(item.auth)">
            <i class="iconfont" :class="item.icon"></i>
            <span slot="title">{{ $t(item.name) }}</span>
        </el-menu-item>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { siderBarList, managementMenu, /* systemMenu, */installMenu, settingMenu, testMenu, queryMenu } from "./menuList.js"
import { mapGetters } from 'vuex'

export default {
  name: "sidebar",
  props: {
    connected: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      siderBarList:[],
      active: localStorage.getItem('sideBarActive') || this.$store.state.sideBarActive,
    }
  },
  watch: {
    connected() {
      return this.$store.state.debugFlag
    },
    sideBarActive(newval) {
      this.active = newval
    },
    startAndStop(val){
      // 不需要禁止点击 注释掉
      // this.setDisabled(!val)
    },
  },
  computed: {
    startAndStop(){
      return this.$store.state.startAndStop
    },
    ...mapGetters([
      'sideBarActive'
    ]),
    sideBarActive:{
      get(){
        return this.$store.state.sideBarActive
      },
      set(val){
        this.$store.state.sideBarActive = val
      }
    },
    controlAuth(){
      return this.$store.state.controlAuth
    },
    uesrAuth(){
      return this.$store.state.userInfo.authorities
    }
  },
  created(){
    this.siderBarList = siderBarList;
  },
  methods: {
    setDisabled(val){
      for (let i in this.siderBarList) {
        let item = this.siderBarList[i];
        item.setDisable = val
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(name) {
      this.sideBarActive = name
      localStorage.setItem('sideBarActive', name)
      this.$store.commit('setSideBarActive', name)
      /*localStorage.setItem('firstActiveName', name)*/
      if (name === 'management') {
        let url = localStorage.getItem('management') || '/management/account'
        this.$router.push(url)
        this.menuList = managementMenu
        this.$emit('changeDisplay', false)
      } else if (name === 'install') {
        let url = localStorage.getItem('install') || '/install/registrationOfComponent'
        this.$router.push(url)
        this.menuList = installMenu
      } else if (name === 'setting') {
        let url = localStorage.getItem('setting') || '/setting/printer'
        this.$router.push(url)
        this.menuList = settingMenu
      } else if (name === 'test') {
        let url = localStorage.getItem('test') || '/test/simulationCurve'
        this.$router.push(url)
        this.menuList = testMenu
      } else if (name === 'query') {
        let url = localStorage.getItem('query') || '/query/registeredAddress'
        this.$router.push(url)
        this.menuList = queryMenu
      } else if (name === 'monitor') {
        let url = localStorage.getItem('monitor') || '/monitor/monitor'
        this.$router.push(url)
        this.menuList = []
      }
      this.$emit('updateSecondMenu', this.menuList, name)
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  padding-top: 20px;
  .el-menu {
    height: 100%;
    width: 80px;
    background: #212A3D;
    border-right: none;

    .el-menu-item {
      line-height: 1;
      text-align: center;
      vertical-align: center;
      height: 80px;
      i {
        color: #ffffff;
      }
      &.is-active{
        color: #00BEFF !important;
        span{
          color: #ffffff !important;
        }
      }
      .iconfont {
        font-size: 28px;
        display: inline-block;
        margin-top: 15px;
        margin-bottom: 7px;
      }

      span {
        display: block;
      }
      &:hover {
        background-color: #000000 !important;
        border-radius: 4px 0 0 4px;
      }
      &.is-active {
        background-color: #00BEFF !important;
        border-top-color: #dce4e6;
        border-bottom-color: #dce4e6;
        color: #ffffff;
        border-radius: 4px 0 0 4px;
      }
    }
  }

  .el-menu-item.is-active {

  }
}
</style>
